import { SDate } from '@summit/core';
import { EboObjectTimeLine } from '../../base-classes/ebo-object-time-line';
import { AssetCondition } from './asset-condition.enum';
import { ValuationSource } from './valuation-source.enum';
import { ValueSelectionType } from './value-selection-type.enum';

export class TruckValuation extends EboObjectTimeLine {
  truckID: string;
  source: ValuationSource;
  //Search values
  odometer: number;
  condition: AssetCondition;
  selectionType: ValueSelectionType;

  noData: boolean;
  purchasePrice: number;
  msrp: number;
  wholesaleBase: number;
  retailBase: number;
  financeBase: number;
  mileageAdjustment: number;
  optionAdjustment: number;
  comment: string;

  constructor(data: Partial<TruckValuation>) {
    super(data);
    this.condition ??= AssetCondition.Unknown;
    this.source ??= ValuationSource.Manual;
    this.selectionType ??= ValueSelectionType.Median;
  }

  get priceBase(): number {
    return this.purchasePrice ?? this.retailBase ?? this.msrp;
  }

  private _valueAdj: number;
  GetValueAdj(year: number, currentOdometer: number): number {
    if (this._valueAdj === undefined) {
      if (this.mileageAdjustment !== undefined && this.mileageAdjustment !== null) {
        this._valueAdj = this.mileageAdjustment;
      } else if (currentOdometer && (this.source !== ValuationSource.PriceDigest || this.priceBase == this.msrp)) {
        const truckYears = SDate.new().diff(SDate.new(`${year - 1}-10-1`), 'year') + 1;
        const mileagePerYear = currentOdometer / truckYears;
        if (mileagePerYear < 120000) {
          this._valueAdj = -1 * mileagePerYear * 0.02 * truckYears;
        } else {
          this._valueAdj = -1 * (119999 * 0.02 * truckYears + (mileagePerYear - 119999) * 0.035 * truckYears);
        }
      }
      this._valueAdj ??= 0;
    }
    return this._valueAdj;
  }

  GetEstimatedValue(year: number, currentOdometer: number): number {
    return this.priceBase ? this.priceBase + this.GetValueAdj(year, currentOdometer) : undefined;
  }
}
